import Proxy from './Proxy';

class EntryProxy extends Proxy
{
    constructor( parameters = {})
    {
        super( 'api/entry', parameters );
    }
}

export default EntryProxy;



// WEBPACK FOOTER //
// ./src/app/proxies/EntryProxy.js